import { combineReducers } from 'redux';

import productsReducer from './products';
import transactionsReducer from './transactions';

export default combineReducers({
	products: productsReducer,
	transactions: transactionsReducer,
});
